import { useRef } from "preact/hooks";
import type { DrawObject, Tool } from "../types/document.ts";
import type { Action } from "../state/actions.ts";
import { useDprCanvas } from "../hooks/use-dpr-canvas.ts";
import { useRenderLoop } from "../hooks/use-render-loop.ts";
import { useCanvasEvents } from "../hooks/use-canvas-events.ts";
import { emojiToCursor } from "../rendering/emoji-cursor.ts";

interface Props {
  objects: DrawObject[];
  inProgress: DrawObject | null;
  canvasWidth: number;
  canvasHeight: number;
  activeTool: Tool;
  activeEmoji: string | undefined;
  activeEmojiSize: number;
  dispatch: (action: Action) => void;
}

function getCursor(tool: Tool, emoji: string | undefined, emojiSize: number): string {
  if (tool === "emoji" && emoji) return emojiToCursor(emoji, emojiSize);
  if (tool === "text") return "default";
  return "crosshair";
}

export function DrawingCanvas({
  objects,
  inProgress,
  canvasWidth,
  canvasHeight,
  activeTool,
  activeEmoji,
  activeEmojiSize,
  dispatch,
}: Props) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useDprCanvas(canvasRef, canvasWidth, canvasHeight);
  useRenderLoop(canvasRef, objects, inProgress, canvasWidth, canvasHeight);
  useCanvasEvents(canvasRef, dispatch, activeTool, activeEmoji);

  return (
    <canvas
      ref={canvasRef}
      class="absolute inset-0 z-10"
      style={{ cursor: getCursor(activeTool, activeEmoji, activeEmojiSize) }}
    />
  );
}
